import { StateCreator } from 'zustand'
//import { InterJSON, Magazine } from '../../Datatypes'

type State = {
    offlineDuration: number,
    favouriteEdition: string,
};

export interface UserSettingsZustandSlice {
    offlineDuration: number,
    favouriteEdition: string,

    updateOfflineDuration: (offlineDuration: State['offlineDuration']) => void
    updateFavouriteEdition: (favouriteEdition: State['favouriteEdition']) => void

    _hasHydrated: boolean
    setHasHydrated: (state: any) => void
}

export const createUserSettingsZustandSlice: StateCreator<UserSettingsZustandSlice> = (set, get) => ({
    offlineDuration: 99,
    favouriteEdition: 'DLZ',

    updateOfflineDuration: (offlineDuration) => set(() => ({ offlineDuration: offlineDuration })),
    updateFavouriteEdition: (favouriteEdition) => set(() => ({ favouriteEdition: favouriteEdition })),

    _hasHydrated: false,
    setHasHydrated: (state: any) => {
        set({
            _hasHydrated: state
        });
    },
});

